module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero15.png?a9d8cbc7";